import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect, 
  useState,
} from 'react'
import LogoImg from '../../../assets/login/logo.png'
import OrdenoLogo from '../../../assets/login/ordeno-logo.png'
import GoogleLogoImg from '../../../assets/login/googlelogo.png'
import ApiService from '../../../services/ApiService'
import UserContext from '../../../contexts/UserContext'
import { useGoogleLogin } from '@react-oauth/google'
import { GoogleLogin } from '@react-oauth/google'
import jwtDecode from 'jwt-decode'
import { validateToken } from '../../../utils/tokenValidation'

import {
  Container,
  MainText,
  LoginForm,
  Label,
  TextInput,
  InputButton,
  PassReset,
  OrLine,
  LeftLine,
  RightLine,
  OrText,
  GoogleDiv,
  RegisterDiv,
  ErrContainer,
} from './style'
import { Logo } from '../style'
import CompleteRegister from '../CompleteRegister'

interface MainBoxProps {
  setPage: (page: string) => void
  setUserlogin: Dispatch<SetStateAction<LoginInfo>>
}

interface LoginInfo {
  email: string
  password: string
}

interface GoogleUser {
  aud: string
  azp: string
  email: string
  email_verified: boolean
  exp: number
  family_name: string
  given_name: string
  iat: number
  iss: string
  jti: string
  name: string
  nbf: number
  picture: string
  sub: string
}

const MainBox: React.FC<MainBoxProps> = (props) => {
  const {
    user,
    setUser,
    googleEmail,
    setGoogleEmail,
    googleName,
    setGoogleName,
    googlePicture,
    setGooglePicture,
    setToken,
  } = useContext(UserContext)
  const [userLogin, setUserLogin] = useState<string>('')
  const [userPassword, setUserPassword] = useState<string>('')
  const [nameButton, setNameButton] = useState<string>('Entrar')
  const [errLogin, setErrLogin] = useState<number>(0)

  useEffect(() => {
    if (user && (user.id || user.sub) && user.approved === 'approved') {
      window.location.href = '/panel'
    } 
    else if (user && (user.id || user.sub) && user.approved !== 'approved') {
      window.location.href = '/accessvalidation'
    }
  }, [user])

  const changePage = (_Page: string) => {
    props.setPage(_Page)
  }

  const handleLogin = async () => {
    console.log('🔑 [LOGIN] Iniciando processo de login:', {
      hasEmail: !!userLogin,
      hasPassword: !!userPassword,
      email: userLogin,
      timestamp: new Date().toISOString()
    })
    
    if (userLogin && userPassword) {
      setNameButton('Entrando')
      setErrLogin(0)
      
      console.log('🔑 [LOGIN] Chamando ApiService.auth.login...')
      
      try {
        const response = await ApiService.auth.login({
          email: userLogin,
          password: userPassword,
        })
        
        console.log('✅ [LOGIN] Resposta do backend recebida:', {
          hasAccessToken: !!response.data.access_token,
          tokenLength: response.data.access_token?.length,
          tokenPreview: response.data.access_token ? `${response.data.access_token.substring(0, 50)}...` : null,
          responseStatus: response.status,
          headers: response.headers
        })
        
        if (response.data.access_token) {
          const token = response.data.access_token
          
          console.log('🔑 [LOGIN] Salvando token no localStorage...')
          localStorage.setItem('token', token)
          
          console.log('🔑 [LOGIN] Validando token...')
          const validation = validateToken(token)
          
          console.log('✅ [LOGIN] Resultado da validação do token:', {
            isValid: validation.isValid,
            isExpired: validation.isExpired,
            hasTenantId: !!validation.tenantId,
            tenantId: validation.tenantId,
            message: validation.message,
            decodedToken: validation.decodedToken
          })
          
          if (validation.decodedToken) {
            console.log('🔑 [LOGIN] Atualizando contexto do usuário...')
            setToken(token)
          } else {
            console.error('❌ [LOGIN] Token decodificado não encontrado')
          }
        } else {
          console.error('❌ [LOGIN] Access token não encontrado na resposta')
        }
      } catch (err) {
        console.error('❌ [LOGIN] Erro durante login:', {
          error: err,
          message: err instanceof Error ? err.message : String(err),
          status: (err as any)?.response?.status,
          data: (err as any)?.response?.data,
          headers: (err as any)?.response?.headers
        })
        setNameButton('Entrar')
        setErrLogin(400)
      }
    } else {
      console.warn('⚠️ [LOGIN] Email ou senha não fornecidos')
    }
  }

  return !googleEmail ? (
    <Container>
      <Logo src={OrdenoLogo} alt='Logo da Ordeno' />
      <MainText> Entre ou cadastre-se no site </MainText>

      <LoginForm>
        <Label htmlFor='email'>Email</Label>
        <TextInput
          type='text'
          name='email'
          value={userLogin}
          onChange={(e) => setUserLogin(e.target.value)}
        />

        <Label htmlFor='password'>Senha</Label>
        <TextInput
          type='password'
          name='password'
          value={userPassword}
          onChange={(e) => setUserPassword(e.target.value)}
        />
        {errLogin === 400 ? (
          <ErrContainer>Email e/ou senha inválidos</ErrContainer>
        ) : null}

        <InputButton
          onClick={() => handleLogin()}
          type='button'
          value={nameButton}
        />
      </LoginForm>

      <PassReset onClick={() => changePage('PassReset')}>
        {' '}
        Esqueci a senha{' '}
      </PassReset>

      <OrLine>
        <LeftLine />
        <OrText>ou</OrText>
        <RightLine />
      </OrLine>

      <GoogleDiv>
        <GoogleLogin
          onSuccess={async (credentialResponse: any) => {
            try {
              const res = await ApiService.auth.googleAuth(credentialResponse)
              
              if (res.data.result.status === 200) {
                const response = res.data.result
                const token = response.data.userToken.access_token

                localStorage.setItem('token', token)
                
                const validation = validateToken(token)
                if (validation.decodedToken) {
                  setToken(token)
                }
              } else {
                const response = res.data.result
                setGoogleEmail(response.data.email)
                setGoogleName(response.data.name)
                setGooglePicture(response.data.picture)

                if (googleEmail && googleName) {
                  window.location.href = '/completeRegister'
                }
              }
            } catch (err: any) {
              console.log(err)
            }
          }}
          onError={() => {
            console.log('Login Failed')
          }}
        />
      </GoogleDiv>

      <RegisterDiv onClick={() => changePage('Register')}>
        <p> Fazer cadastro </p>
      </RegisterDiv>
    </Container>
  ) : (
    <CompleteRegister />
  )
}

export default MainBox